
import React from 'react'
import { Dialog, DialogTitle, DialogContent, Typography, DialogActions, Button, makeStyles,
    List, ListItem, ListItemText } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    heading: {
        fontSize: theme.typography.pxToRem(17),
        fontWeight: theme.typography.fontWeightRegular,
    },
}));

export const ConfirmControl = ( props ) => {

    const classes = useStyles();

    const { onSubmit, onClose, open, dni, nombre, alerta, ...other } = props;

    const handleCancel = () => {
        onClose();
    };

    const handleOk = () => {
        onSubmit();
    };

    return (
        <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="xs"
        aria-labelledby="confirmation-dialog-title"
        open={open}
        {...other}
        >
            {
                alerta
                ?
                    <DialogTitle id="confirmation-dialog-title">Alerta!</DialogTitle>
                :
                    <DialogTitle id="confirmation-dialog-title">¿Desea recargar la página?</DialogTitle>
            }
            <DialogContent dividers>
                {/* <Typography className={ classes.heading }>
                    ¿Desea registrar la veeduría escolar?
                </Typography> */}
                {
                    
                    alerta
                    ?
                        <Typography className={ classes.heading }>
                            Debe seleccionar la autorización de registro.
                        </Typography>
                    :
                        <Typography className={ classes.heading }>
                            Se perderán todos los datos ingresados
                        </Typography>
                }

                {/* <List component="div" role="list">
                    <ListItem button divider disabled role="listitem">
                    </ListItem>
                    <ListItem button divider role="listitem">
                        <ListItemText primary={ nombre } secondary={ dni } style={ { textTransform: 'capitalize' } } />
                    </ListItem>
                </List> */}

            </DialogContent>
            <DialogActions>
            
                <div style={{ display: 'flex', width: '100%' }}>
                    {
                        alerta
                        ?
                            <div>
                                <Button onClick={ handleOk } color="primary"
                                type="submit" 
                                variant="contained">
                                    Aceptar
                                </Button>
                            </div>
                        :
                            <>
                                <div style={{ display: 'flex', flexGrow: 1 }}>
                                    <Button autoFocus onClick={ handleCancel } color="primary"
                                    variant="outlined">
                                    Cancelar
                                    </Button>
                                </div>
                                <div style={{ display: 'inline-flex', flex: "0 0 auto" }}>
                                    <Button onClick={ handleOk } color="primary"
                                    type="submit" 
                                    variant="contained">
                                        Aceptar
                                    </Button>
                                </div>
                            </>
                    }
                </div>

            </DialogActions>
        </Dialog>
    )
}
